<template>
  <div class="app-wrap">
    <div class="app-home">
      <div v-if="false" class="app-title">欢迎使用智能制造中台！</div>
      <el-row type="flex" :gutter="24">
        <!-- 设备状态概览 -->
        <el-col :span="10">
          <div class="device-summary">
            <el-card class="self-card hover-card">
              <div slot="header">
                <span>{{ $t("home.deviceStatus") }}</span>
              </div>
              <div class="content">
                <div class="status-left">
                  <div class="tip">{{ $t("home.totalNumber") }}</div>
                  <div class="title">{{ status.total && status.total.toLocaleString() }}</div>
                  <div class="status-num">
                    <div class="num-item">
                      <div class="tip">{{ $t("home.online") }}</div>
                      <div class="num themeGreen fn18">{{ status.online }}</div>
                    </div>
                    <div class="num-item">
                      <div class="tip">{{ $t("home.offline") }}</div>
                      <div class="num themeRed fn18">{{ status.offline }}</div>
                    </div>
                    <div class="num-item">
                      <div class="tip">{{ $t("home.inactivated") }}</div>
                      <div class="num fn18" style="color: #9ea5b2">{{ status.inactivated }}</div>
                    </div>
                  </div>
                </div>
                <div class="status-charts">
                  <device-status ref="deviceRef" :prop-data="deviceStatusPropData" class="h100" />
                </div>
                <div class="content-right status-right">
                  <div class="num-item" :title="`${$t('home.powerOn')} ${status.boot}`">
                    <span class="label">{{ $t("home.powerOn") }}</span>
                    <span>{{ status.boot }}</span>
                  </div>
                  <div class="num-item" :title="`${$t('home.downtime')} ${status.shutdown}`">
                    <span class="label">{{ $t("home.downtime") }}</span>
                    <span>{{ status.shutdown }}</span>
                  </div>
                  <div class="num-item" :title="`${$t('home.operation')} ${status.work}`">
                    <span class="label">{{ $t("home.operation") }}</span>
                    <span>{{ status.work }}</span>
                  </div>
                  <div class="num-item" :title="`${$t('home.bottleneck')} ${status.bottleneck}`">
                    <span class="label">{{ $t("home.bottleneck") }}</span>
                    <span>{{ status.bottleneck }}</span>
                  </div>
                  <div class="num-item" :title="`${$t('home.standby')} ${status.standby}`">
                    <span class="label">{{ $t("home.standby") }}</span>
                    <span>{{ status.standby }}</span>
                  </div>
                  <div class="num-item" :title="`${$t('home.redundancy')} ${status.redundant}`">
                    <span class="label">{{ $t("home.redundancy") }}</span>
                    <span>{{ status.redundant }}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <!-- 生产效率概览 -->
        <el-col :span="7">
          <div class="product-summary">
            <el-card class="self-card hover-card">
              <div slot="header">
                <span>{{ $t("home.productionEfficiency") }}</span>
              </div>
              <div class="content">
                <div class="product-left">
                  <div class="tip">{{ $t("home.powerOnRate") }}</div>
                  <div class="title">{{ efficiency.bootRate }}%</div>
                  <div class="product-num">
                    <div class="progress">
                      <div class="back" :style="{ width: `${efficiency.bootRate}%` }" />
                    </div>
                  </div>
                </div>
                <div class="content-right product-right">
                  <div
                    class="num-item"
                    :title="`${$t('home.peakingRate')} ${efficiency.topPeakRate}%`"
                  >
                    <span class="label">{{ $t("home.peakingRate") }}</span>
                    <span>{{ efficiency.topPeakRate }}%</span>
                  </div>
                  <div
                    class="num-item"
                    :title="`${$t('home.bottleneckRate')} ${efficiency.bottleneckRate}%`"
                  >
                    <span class="label">{{ $t("home.bottleneckRate") }}</span>
                    <span>{{ efficiency.bottleneckRate }}%</span>
                  </div>
                  <div
                    class="num-item"
                    :title="`${$t('home.operationRate')} ${efficiency.workRate}%`"
                  >
                    <span class="label">{{ $t("home.operationRate") }}</span>
                    <span>{{ efficiency.workRate }}%</span>
                  </div>
                  <div
                    class="num-item"
                    :title="`${$t('home.redundancyRate')} ${efficiency.redundantRate}%`"
                  >
                    <span class="label">{{ $t("home.redundancyRate") }}</span>
                    <span>{{ efficiency.redundantRate }}%</span>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <!-- 能源消耗概览 -->
        <el-col :span="7">
          <div class="energy-summary">
            <el-card class="self-card hover-card">
              <div slot="header">
                <span>{{ $t("home.energyConsumption") }}</span>
              </div>
              <div class="content" style="flex-direction: column">
                <div style="height: 64px">
                  <div class="tip">{{ $t("home.powerConsumptionToday") }}</div>
                  <div class="title">{{ efficiency.consumption }}</div>
                </div>
                <div class="energy-bottom">
                  <energy-trend ref="energyRef" :prop-data="energyPropData" class="h100" />
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="24">
        <el-col :span="17">
          <!-- 应用中心 -->
          <div v-if="rootCloudAppList.length > 0" class="app-center">
            <el-card class="self-card" :body-style="{ display: 'flex' }">
              <div slot="header">
                <span>{{ $t("home.applicationCenter") }}</span>
              </div>
              <div
                v-for="item in rootCloudAppList"
                v-show="item.applicationCode !== 'mdm'"
                :key="item.applicationId"
                class="app-item hover-card"
                @click="goHref(item)"
              >
                <div class="logo-wrapper">
                  <div class="logo" :class="{ noLogo: !item.applicationIcon }">
                    <img
                      v-if="item.applicationIcon"
                      style="width: 28px; height: 28px"
                      :src="item.applicationIcon"
                      alt=""
                    />
                    <!-- 增加了默认图片 -->
                    <img
                      v-else
                      src="../../../assets/images/rc.png"
                      style="width: 28px; height: 28px"
                    />
                  </div>
                </div>
                <div class="app-label" style="height: 55px">
                  <el-tooltip effect="dark" :content="item.applicationName" placement="top-start">
                    <label class="fnM" style="margin-bottom: 13px; display: block">
                      {{ item.applicationName }}
                    </label>
                  </el-tooltip>
                  <!-- {'des-not-overflow': item.description.length <= 23} -->
                  <el-tooltip
                    v-if="item.desSubNum"
                    effect="dark"
                    :content="item.description"
                    placement="top-start"
                  >
                    <p class="app-description">
                      {{ `${item.description.substring(0, item.desSubNum)}...` }}
                    </p>
                  </el-tooltip>
                  <p v-else class="app-description">{{ item.description || "" }}</p>
                </div>
                <!-- <div v-if="!item.description" class="app-label">{{ item.applicationName }}</div> -->
                <div v-if="userInfo.isAdmin" class="tip">
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    :visible-arrow="false"
                    style="margin-left: 15px"
                    popper-class="scim-common-theme scim-common-theme-green"
                    class="cursor-p self-popover hover-popover"
                  >
                    <span slot="reference">
                      <i class="el-icon-more" style="transform: rotate(90deg)" />
                    </span>
                    <div class="self-popover-items" style="width: 100px">
                      <p class="self-popover-item" @click="handleEditShow(item)">编辑</p>
                    </div>
                  </el-popover>
                </div>
              </div>
            </el-card>
          </div>
          <div v-if="rootCloudAppList.length === 0" class="app-center">
            <el-card class="self-card" :body-style="{ display: 'flex' }">
              <div slot="header">
                <span>{{ $t("home.applicationCenter") }}</span>
              </div>
              <div class="empty-item">
                <div>
                  <i class="el-icon-warning-outline fn16" />
                  <span>{{ $t("home.notSubscribed") }}</span>
                </div>
              </div>
            </el-card>
          </div>
          <!--基础服务-->
          <div v-if="moduleList.length > 0" class="basic-service">
            <el-card class="self-card" style="min-height: 245px">
              <div slot="header">
                <span>{{ $t("home.basicServices") }}</span>
              </div>
              <div
                v-for="item in moduleList"
                v-show="item.applicationCode !== 'mdm'"
                :key="item.applicationId"
                class="service-item hover-card"
                @click="enterModule(item)"
              >
                <div class="avatar-wrapper">
                  <div class="logo-avatar">
                    <img
                      v-if="item.applicationIcon"
                      style="width: 28px; height: 28px"
                      :src="item.applicationIcon"
                      alt=""
                    />
                    <!-- <div v-else style="width: 24px;height:24px;">暂无图片</div> -->
                  </div>
                </div>
                <div class="service-label fnM">{{ item.applicationName }}</div>
              </div>
            </el-card>
          </div>
          <div v-if="moduleList.length === 0" class="basic-service">
            <el-card class="self-card" :body-style="{ display: 'flex' }">
              <div slot="header">
                <span>{{ $t("home.basicServices") }}</span>
              </div>
              <div class="empty-item">
                <div>
                  <i class="el-icon-warning-outline fn16" />
                  <span>{{ $t("home.notSubscribed") }}</span>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <!-- 报警统计 -->
        <el-col :span="7">
          <div class="alarm-statis">
            <el-card class="self-card hover-card" style="padding-bottom: 10px">
              <div slot="header">
                <span>{{ $t("home.alarmStatistics") }}</span>
              </div>
              <div style="width: 100%; height: 400px">
                <div class="alarmTotal-text">{{ $t("home.totalAlarms") }}</div>
                <div class="countText">{{ alarmTotalCount }}</div>
                <alarmChart ref="warnChart" :prop-data="warnData" class="h50" />
                <div>
                  <div class="itemDiv itemDiv-serious">
                    <span class="itemSpan serious">{{ warnData[0].name }}</span>
                    <span class="num">{{ warnData[0].value }}</span>
                  </div>
                  <div class="itemDiv itemDiv-general">
                    <span class="itemSpan general">{{ warnData[1].name }}</span>
                    <span class="num">{{ warnData[1].value }}</span>
                  </div>
                  <div class="itemDiv itemDiv-non">
                    <span class="itemSpan non">{{ warnData[2].name }}</span>
                    <span class="num">{{ warnData[2].value }}</span>
                  </div>
                </div>
                <!-- <div v-for="(item,index) of  warnData" :key="index">
                  <div>
                    <div class="itemDiv"><span class="itemSpan">{{item.name}}</span>{{item.value}}</div>
                  </div>
                </div> -->
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
    <edit-app
      :visible.sync="editDialogVisible"
      :prop-data="editFormData"
      :prop-loading="editLoading"
      @confirm="handleEditConfirm"
    />
  </div>
</template>

<script>
import { portal } from "@/api/other/portal";
import DeviceStatus from "@/views/standard/home/components/deviceStatus";
import EnergyTrend from "@/views/standard/home/components/energyTrend";
import alarmChart from "@/views/standard/home/components/alarmChart";
import editApp from "@/views/standard/home/components/editApp";
import { alarmListApi } from "@/api/other/alarmList";
import { modulePathList } from "@/utils/settings";
import { application } from "@/api/other/sysManage";
import user from "@/api/other/user";
export default {
  name: "Commonhome",
  components: { EnergyTrend, DeviceStatus, alarmChart, editApp },
  data() {
    return {
      status: {
        total: 0,
        online: 0,
        offline: 0,
        inactivated: 0,
        boot: 0,
        shutdown: 0,
        work: 0,
        bottleneck: 0,
        standby: 0,
        redundant: 0
      },
      deviceStatusPropData: [
        {
          name: this.$t("home.online"),
          value: 0,
          itemStyle: {
            color: "#00B259"
          }
        },
        {
          name: this.$t("home.offline"),
          value: 0,
          itemStyle: {
            color: "#E60000"
          }
        },
        {
          name: this.$t("home.inactivated"),
          value: 0,
          itemStyle: {
            color: "#d9dadb",
            opacity: 1
          }
        }
      ],
      energyPropData: {
        xAxisData: [],
        seriesData: []
      },
      efficiency: {
        bootRate: 0,
        topPeakRate: 0,
        bottleneckRate: 0,
        workRate: 0,
        redundantRate: 0,
        consumption: 0
      },
      // 根云服务
      rootCloudAppList: [],
      externalAccessAppList: [],
      // 基础服务列表
      moduleList: [],
      warnItemsList: [],
      warnData: [
        { name: this.$t("home.seriousFailure"), value: 0, color: "red" },
        { name: this.$t("home.generalFailure"), value: 0, color: "red" },
        { name: this.$t("home.nonFailure"), value: 0, color: "red" }
      ],
      alarmTotalCount: 0,
      editDialogVisible: false,
      editLoading: false,
      editFormData: {}
    };
  },
  computed: {
    tenantId() {
      return this.$store.getters.tenantId;
    },
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  mounted() {
    this.getMetric();
    this.getHomeEnergyChart();
    this.getWarnData();
    if (!this.userInfo.isSysAdmin) {
      this.$nextTick(() => {
        this.moduleList = this.$store.getters.appList.moduleList.filter(
          item => item.applicationCode !== "usercenter"
        );
        this.rootCloudAppList = this.$store.getters.appList.rootCloudAppList;
        this.generateModuleList(this.rootCloudAppList);
      });
    }
  },

  /*
   * beforeDestroy() {
   *   window.removeEventListener('resize', this.warnChart.resize)
   * },
   */
  methods: {
    // 计算截取字符串的长度
    generateModuleList(source) {
      source.forEach(item => {
        let len = 0;
        if (item.description) {
          for (let i = 0; i < item.description.length; i++) {
            if (item.description.charCodeAt(i) > 127 || item.description.charCodeAt(i) === 94) {
              len += 2;
            } else {
              len++;
            }
            if (len >= 30) {
              this.$set(item, "desSubNum", i - 1);
              break;
            }
          }
        }
      });
    },
    enterModule(item) {
      const module = modulePathList.find(i => i.code === item.applicationCode) || null;
      if (module) {
        this.$router.push(module.path);
      }
    },
    // 获取驾驶舱数据
    getMetric() {
      portal.getHomeMetric().then(res => {
        if (res.resultCode === 200) {
          this.status = {
            ...res.data.equipmentStatusCount
          };
          this.deviceStatusPropData[0].value = res.data.equipmentStatusCount.online;
          this.deviceStatusPropData[1].value = res.data.equipmentStatusCount.offline;
          this.deviceStatusPropData[2].value = res.data.equipmentStatusCount.inactivated;
          this.efficiency = {
            bootRate: res.data.bootRate || 0,
            topPeakRate: res.data.topPeakRate || 0,
            bottleneckRate: res.data.bottleneckRate || 0,
            workRate: res.data.workRate || 0,
            redundantRate: res.data.redundantRate || 0,
            consumption: res.data.consumption || 0
          };
          // 防止echarts动画未结束赋值影响加载结果
          setTimeout(() => {
            this.$refs.deviceRef.initStatus();
          }, 1100);
        }
      });
    },
    // 获取能源消耗
    getHomeEnergyChart() {
      portal.getHomeEnergyChart().then(res => {
        if (res.resultCode === 200) {
          this.energyPropData.xAxisData = [];
          this.energyPropData.seriesData = [];
          res.data.forEach(val => {
            this.energyPropData.xAxisData.push(val.day);
            this.energyPropData.seriesData.push(val.consumption);
            this.$refs.energyRef.initEnergy();
          });
        }
      });
    },
    // 获取报警数据
    getWarnData() {
      this.warnItemsList = [];
      const sendData = [1, 2, 3];
      alarmListApi
        .getHomeCount(sendData)
        .then(res => {
          const { data } = res;
          // console.log(data)
          if (data["3"]) {
            this.warnData[0].value = data["3"];
            this.alarmTotalCount = this.alarmTotalCount + data["3"];
          }
          if (data["2"]) {
            this.warnData[1].value = data["2"];
            this.alarmTotalCount = this.alarmTotalCount + data["2"];
          }
          if (data["1"]) {
            this.warnData[2].value = data["1"];
            this.alarmTotalCount = this.alarmTotalCount + data["1"];
          }
          setTimeout(() => {
            this.$refs.warnChart.initStatus();
          }, 1100);
        })
        .catch(() => {
          // console.log('报错了')
        });
    },

    /**
     * 跳转对应的应用地址
     */
    goHref(data) {
      /*
       * 测试小匠
       *   let protocol = document.location.protocol;
       *  if(data.applicationCode=='root-worker'){
       *     let devUrl=`${protocol}//ui.rootcloudapp.com:4240`
       *     let qaUrl= `${protocol}//front-feas-bi.bdn-cimfusion-iot-qa.rootcloudapp.com` //域名不一样,无法共享cookie
       *     window.open(qaUrl)
       *  }
       *  else window.open(data.href)
       */
      if (data.applicationCode === "mes") {
        user.getToken().then(res => {
          if (res.resultCode === 200) {
            window.open(`${data.href}?mes_access_token=${res.data}`);
          }
        });
      } else {
        window.open(data.href);
      }
    },
    // 编辑应用
    handleEditShow(item) {
      // console.log(item)
      this.editFormData = {
        ...item,
        type: "app"
      };
      this.editDialogVisible = true;
    },
    // 确认编辑应用
    handleEditConfirm(data) {
      this.editLoading = true;
      const formData = new FormData();
      formData.append("applicationIcon", data.applicationIcon);
      formData.append("applicationId", data.applicationId);
      formData.append("applicationName", data.applicationName);
      formData.append("description", data.description);
      formData.append("file", data.file);
      application
        .updateApplication(formData)
        .then(res => {
          if (res.resultCode === 200) {
            this.$message.closeAll();
            this.$store
              .dispatch("user/getResource")
              .then(() => {
                this.rootCloudAppList = this.$store.getters.appList.rootCloudAppList;
                this.generateModuleList(this.rootCloudAppList);
                this.$message.success("编辑成功");
                this.editLoading = false;
                this.editDialogVisible = false;
              })
              .catch(() => {
                this.editLoading = false;
              });
          }
        })
        .catch(() => {
          this.editLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.itemDiv {
  max-width: 224px;
  width: 60%;
  text-align: right;
  margin-bottom: 16px;
  line-height: 24px;
  padding-right: 14px;
  .num {
    font-family: DINCondensed-Regular, DINCondensed;
  }
}
.itemSpan {
  min-width: 78px;
  padding: 0 8px;
  text-align: center;
  background: #ffffff;
  float: left;
  margin-left: 5px;
  font-family: PingFangSC-Medium, PingFang SC;
}
.itemDiv-serious {
  margin-top: 20px;
  // background: #E60000;
  background: rgba(230, 0, 0, 0.15);
  color: #e60000;
  .serious {
    background: rgba(255, 255, 255, 0.3);
    color: #e60000;
  }
}
.itemDiv-general {
  // background: #FF6922;
  background: rgba(255, 105, 34, 0.15);
  color: #ff6922;
  .general {
    background: rgba(255, 255, 255, 0.3);
    color: #ff6922;
  }
}
.itemDiv-non {
  // background: #FF9900;
  background: rgba(255, 153, 0, 0.15);
  color: #ff9900;
  .non {
    background: rgba(255, 255, 255, 0.3);
    color: #ff9900;
  }
}
.countText {
  font-size: 32px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
.alarmTotal-text {
  font-size: 14px;
  font-weight: 400;
  color: #505363;
  padding-bottom: 15px;
}
.h50 {
  height: 45%;
}
.app-wrap {
  min-width: 1400px;
  overflow: hidden;
  background: #f9f9f9;
}
.app-home {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 26px 40px 0 40px;
  .app-title {
    margin-bottom: 24px;
    font-size: 18px;
    color: #21252e;
  }
  .content {
    width: 100%;
    height: 130px;
    display: flex;
    .tip {
      font-size: 14px;
      color: #505363;
      margin-bottom: 8px;
    }
    .title {
      font-size: 32px;
      font-family: DINCondensed-Regular, DINCondensed;
      color: rgba(0, 0, 0, 0.85);
    }
    .content-right {
      .num-item {
        width: 50%;
        height: 34px;
        line-height: 24px;
        padding-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .label {
          margin-right: 8px;
          color: #505363;
          & + span {
            color: #21252e;
            font-family: DINCondensed-Regular, DINCondensed;
          }
        }
      }
    }
  }
  .device-summary {
    .status-left {
      flex: 2;
      display: flex;
      flex-direction: column;
      .status-num {
        flex: 1;
        display: flex;
        .num-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding-bottom: 8px;
          .num {
            font-family: DINCondensed-Regular, DINCondensed;
          }
          & + .num-item {
            margin-left: 24px;
          }
        }
      }
    }
    .status-charts {
      flex: 1;
      padding: 0 20px;
      border-right: 1px solid #f5f7fa;
    }
    .status-right {
      flex: 2;
      padding-left: 20px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-end;
    }
  }
  .product-summary {
    .product-left {
      flex: 3;
      display: flex;
      flex-direction: column;
    }
    .product-num {
      flex: 1;
      display: flex;
      position: relative;
      padding-right: 24px;
      .progress {
        width: calc(100% - 24px);
        height: 10px;
        position: absolute;
        bottom: 30px;
        background: #f0f2f5;
        .back {
          height: 10px;
          background: #00b259;
        }
      }
    }
    .product-right {
      flex: 5;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-end;
    }
  }
  .energy-summary {
    .energy-bottom {
      padding-bottom: 8px;
      flex: 1;
    }
  }
  .self-card {
    margin-bottom: 24px;
    box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.03);
    border: none;
    ::v-deep .el-card__header {
      font-size: 16px;
      line-height: 44px;
      span {
        font-weight: 500;
        color: #4f5363;
        font-family: PingFangSC-Medium, PingFang SC;
      }
    }
    ::v-deep .el-card__body {
      padding: 24px;
      display: flex;
      flex-wrap: wrap;
    }
    .app-item,
    .service-item {
      width: 284px;
      height: 92px;
      display: flex;
      align-items: center;
      padding-left: 28px;
      box-shadow: 0 1px 3px 0 rgba(33, 37, 46, 0.12);
      border: 1px solid #dadfea;
      // padding: 20px;
      margin-right: 14px;
      margin-bottom: 14px;
      cursor: pointer;
      position: relative;
      .avatar-wrapper {
        height: 52px;
        line-height: 52px;
        position: relative;
        margin-right: 16px;
        .logo-avatar {
          display: flex;
          justify-content: center;
          width: 52px;
          height: 52px;
          border-radius: 26px;
          background-color: #00b259;
          text-align: center;
          align-items: center;
          line-height: 52px;
          font-size: 14px;
          color: #fff;
        }
      }
      .logo-wrapper {
        height: 64px;
        line-height: 64px;
        position: relative;
        margin-right: 24px;
        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 52px;
          height: 52px;
          border-radius: 26px;
          text-align: center;
          line-height: 52px;
          font-size: 14px;
          color: #fff;
          border: 1px solid #c6ccd7;
        }
      }
      .app-label,
      .service-label {
        color: #21252e;
        width: 96px;
        height: 24px;
        font-size: 18px;
        font-weight: 500;
        .app-description {
          position: relative;
          width: 113px;
          height: 54px;
          line-height: 18px;
          overflow: hidden;
          color: #868790;
          font-size: 14px;
          word-break: break-all;
          font-weight: 400;
        }
        // .des-overflow {
        //   &::after {
        //     content: "...";
        //     position: absolute;
        //     bottom: 0;
        //     right: 0;
        //     padding-left: 18px;
        //     background: -webkit-linear-gradient(left, transparent, #fff 55%);
        //     background: -o-linear-gradient(right, transparent, #fff 55%);
        //     background: -moz-linear-gradient(right, transparent, #fff 55%);
        //     background: linear-gradient(to right, transparent, #fff 55%);
        //   }
        // }
        label {
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: normal;
          white-space: nowrap;
        }
      }
      .app-label {
        font-size: 18px;
        label {
          width: 140px;
        }
      }
      .tip {
        position: absolute;
        top: 8px;
        right: 8px;
      }
    }
    .empty-item {
      color: #21252e;
      width: 100%;
      display: flex;
      justify-content: center;
      div {
        width: 475px;
        display: flex;
        align-items: center;
      }
      i {
        padding-right: 8px;
      }
      span {
        font-weight: 400;
      }
    }
    .app-item {
      height: 128px;
    }
  }
  .app-center-empty {
    width: 100%;
    height: 88px;
    background-color: #fff;
  }
  .hover-card {
    transition: all 0.3s;
    &:hover {
      box-shadow: 0 4px 16px 0 rgba(33, 37, 46, 0.12);
    }
  }
}
</style>
